module.exports = __webpack_public_path__ + "img/12.ec29e058.png";